module.exports = __webpack_public_path__ + "media/images/wishlist-de182a4d34cad5c0bda5fc3dc1b4a0f6.svg";